<template>
  <!-- 圆形图表 -->
  <div :ref="refId" :datas="datas" style="width: 100%; height: 100%"></div>
</template>

<script>
// refId                   图表id
// datas                   图表数据源
// innerText               待定
// isScroll                图例组建是否需要滚动
// height                  图例的高度
// colorName               看取那个色值的名称
// legendLeft              图例组建的左边left距离
// seriesRight             饼图的右边right距离
// titleLeft               title的左边距离
// legendBackgroundColor   图例组建，背景颜色等是否是白色或者灰色
// isSort                  是否排序数据源
// circleSize              设置圈的大小
// circleFontSize          设置圈内字体大小
// isTotalSimplify         是否需要简化总数值
// pieCenter               移动饼图位置
// showValue               是否在legend中显示数值
//unit                     在legend中显示数值的单位
// isShowTextColor         是否导出时候横轴纵轴显示设置字体25
// isExportTextColor       是否给导出页面时候legend文字大小
// legendListFontSize      字体大小

export default {
  props: [
    "refId",
    "datas",
    "innerText",
    "isScroll",
    "height",
    "colorName",
    "legendLeft",
    "seriesRight",
    "titleLeft",
    "legendBackgroundColor",
    "isSort",
    "circleSize",
    "circleFontSize",
    "isTotalSimplify",
    "pieCenter",
    "showValue",
    "unit",
    "isShowTextColor",
    "isExportTextColor",
    "legendListFontSize",
  ],
  data() {
    return {
      pieEcharts: "",
      pieOption: {},
    };
  },
  watch: {
    datas: {
      handler(newValue, oldValue) {
        this.setPieOption(
          this.refId,
          newValue,
          this.innerText,
          this.isScroll,
          this.height,
          this.colorName,
          this.legendLeft,
          this.seriesRight,
          this.titleLeft,
          this.legendBackgroundColor,
          this.isSort,
          this.circleSize,
          this.circleFontSize,
          this.isTotalSimplify,
          this.pieCenter,
          this.showValue,
          this.unit,
          this.isShowTextColor,
          this.isExportTextColor,
          this.legendListFontSize
        );
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.pieEcharts) {
      this.pieEcharts.clear();
    }
  },
  mounted() {
    if (this.datas && this.datas.length > 0) {
      this.setPieOption(
        this.refId,
        this.datas,
        this.innerText,
        this.isScroll,
        this.height,
        this.colorName,
        this.legendLeft,
        this.seriesRight,
        this.titleLeft,
        this.legendBackgroundColor,
        this.isSort,
        this.circleSize,
        this.circleFontSize,
        this.isTotalSimplify,
        this.pieCenter,
        this.showValue,
        this.unit,
        this.isShowTextColor,
        this.isExportTextColor,
        this.legendListFontSize
      );
    }
  },
  methods: {
    setPieOption(
      refId,
      datas,
      innerText,
      isScroll,
      height,
      colorName,
      legendLeft,
      seriesRight,
      titleLeft,
      legendBackgroundColor,
      isSort,
      circleSize,
      circleFontSize,
      isTotalSimplify,
      pieCenter,
      showValue,
      unit,
      isShowTextColor,
      isExportTextColor,
      legendListFontSize
    ) {
      let data = JSON.stringify(datas);
      data = JSON.parse(data);
      if (data.length > 0 && !isSort) {
        data = data.sort((a, b) => b.value - a.value);
        for (let i = 0; i < data.length; i++) {
          data[i].value = data[i].value ? Number(data[i].value) : 0;
        }
      }

      let colorList = [];
      if (colorName == 1) {
        colorList = [
          "#3B86FF",
          "#5697FF",
          "#3FBBFE",
          "#66CAFE",
          "#7F88FE",
          "#BBA8FF",
          "#CACEFE",
          "#A3FFF8",
          "#63D0FF",
          "#82DAFF",
          "#4FC9FC",
          "#8EF1FF",
          "#6DD0D8",
          "#9FD5FF",
          "#79C6F8",
          "#31D8F8",
          "#11CBFF",
          "#6ACFFF",
          "#64BFFF",
          "#5093FF",
          "#FFCBD1",
        ]; // 蓝色
      } else if (colorName == 2) {
        colorList = [
          "#FD398E",
          "#FE6695",
          "#FE80A7",
          "#FBBBD7",
          "#FED0E4",
          "#FCDFF3",
          "#FFB1E7",
          "#FFA5D5",
          "#FF98B7",
          "#FEAAA0",
          "#FFBFAF",
          "#FFD1A2",
          "#FBE0BD",
          "#FEFFDF",
          "#FFDEE6",
          "#FFBFDB",
          "#FFD1E4",
          "#FCD4D8",
          "#FFAFC2",
          "#FF6D9F",
          "#FFCBD1",
        ]; // 粉色
      } else if (colorName == 3) {
        colorList = [
          "#7F88FE",
          "#BBA8FF",
          "#CACEFE",
          "#3FBBFE",
          "#66CAFE",
          "#A3FFF8",
          "#FCDFF3",
          "#FBBBD7",
          "#FED0E4",
          "#FBE0BD",
        ]; // 蓝色顺序改变
      } else if (colorName == 4) {
        colorList = [
          "#7F88FE",
          "#BBA8FF",
          "#CACEFE",
          "#A3FFF8",
          "#63D0FF",
          "#82DAFF",
          "#4FC9FC",
          "#8EF1FF",
          "#6DD0D8",
          "#9FD5FF",
          "#79C6F8",
          "#31D8F8",
          "#11CBFF",
          "#6ACFFF",
          "#64BFFF",
          "#5093FF",
          "#FFCBD1",
        ]; // 蓝色
      } else if (colorName == 5) {
        colorList = [
          "#7F88FE",
          "#63D0FF",
          "#A3FFF8",
          "#BBA8FF",
          "#63D0FF",
          "#82DAFF",
          "#4FC9FC",
          "#8EF1FF",
          "#6DD0D8",
          "#9FD5FF",
          "#79C6F8",
          "#31D8F8",
          "#11CBFF",
          "#6ACFFF",
          "#64BFFF",
          "#5093FF",
          "#FFCBD1",
        ]; // 蓝色
      }

      const legendData = [];
      const seriesData = [];
      let total = 0;

      for (let i = 0; i < data.length; i++) {
        total += parseFloat(data[i].value);
      }
      for (let j = 0; j < data.length; j++) {
        if (data[j].value != 0) {
          var names = `${data[j].name}  ${
            showValue ? `${data[j].value}${unit ? unit : ""} ` : ""
          }  ${parseFloat(((data[j].value / total) * 100).toFixed(2))}%`;
        } else {
          var names = `${data[j].name}  ${
            showValue ? `${data[j].value}${unit ? unit : ""}` : ""
          }  0%`;
        }
        legendData.push(names);
        seriesData.push({
          // itemStyle: data[j].itemStyle,
          itemStyle: {
            normal: {
              color: colorList[j],
            },
          },
          name: names,
          value: data[j].value,
        });
      }

      if (!innerText) {
        innerText = "";
      } else {
        innerText = `(${innerText})`;
      }

      // 是否需要简化总数
      if (isTotalSimplify) {
        total = this.unitMethod(total, "")[0] + this.unitMethod(total, "")[1];
      }

      this.pieEcharts = this.$echarts.init(this.$refs[refId]);
      this.pieOption = {
        title: {
          zlevel: 0,
          top: "center",
          left: titleLeft || "31%",
          textAlign: "center",
          text: [`{value|${total}}`, "{name|总数}"].join("\n"),
          rich: {
            value: {
              color: "#bcc2cf",
              fontSize: 30,
              fontWeight: "bold",
              lineHeight: 40,
            },
            name: {
              color: "#bcc2cf",
              lineHeight: 20,
            },
          },
          textStyle: {
            rich: {
              value: {
                // fontSize: circleSize ? circleSize / 3 : 20,
                color: !legendBackgroundColor ? "#FFFFFF" : "#262A3E",
                fontSize:
                  circleSize && circleFontSize
                    ? circleFontSize
                    : circleSize && !circleFontSize
                    ? circleSize / 3
                    : 20,
                fontWeight: "bold",
                lineHeight: circleFontSize ? circleFontSize * 2 : 40,
                align: "center",
                // lineHeight: circleFontSize ? circleFontSize : 40,
              },
              name: {
                // fontSize: circleSize ? circleSize / 3.8 : 16,
                // fontSize: circleSize && !circleFontSize ? circleSize / 3 : circleSize && circleFontSize ? circleFontSize : 20,
                // lineHeight: circleFontSize ? circleFontSize : 40,
                fontSize:
                  circleSize && circleFontSize
                    ? circleFontSize
                    : circleSize && !circleFontSize
                    ? circleSize / 3
                    : 20,
                color: !legendBackgroundColor ? "#FFFFFF" : "#262A3E",

                lineHeight:
                  circleFontSize && circleFontSize
                    ? circleFontSize
                    : circleSize
                    ? circleSize / 3
                    : 10,
                align: "center",
              },
            },
          },
        },
        tooltip: {
          trigger: "item",
          confine: true, // 浮窗限制在图表内
          backgroundColor: "rgba(64, 80, 118, 0.8)", // 通过设置rgba调节背景颜色与透明度
          borderColor: "rgba(64, 80, 118, 0.8)",
          color: "#fff",
          textStyle: {
            color: "#fff",
          },
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
          formatter: (name) => {
            const src = `${name.marker} ${name.data.name} &nbsp;&nbsp; ${name.data.value}<br/>`;
            if (!name.data.name) {
              return;
            }
            return src;
          },
          // formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          icon: "circle",
          orient: "vertical",
          type: isExportTextColor ? "plain" : isScroll ? "scroll" : "plain",
          left: legendLeft || "58%",
          top: "center",
          align: "left",
          height,
          padding: [15, 10, 15, 10],
          itemWidth: 13,
          itemHeight: 13,
          shadowBlur: 10,
          shadowOffsetY: 0,
          shadowOffsetX: 0,
          itemGap: 10,
          // backgroundColor:this.$echarts.graphic.LinearGradient(
          //   0, 0, 0, 1,
          //   [
          //     { offset: 0, color: 'rgba(40,55,92,1)' },
          //     { offset: 1, color: 'rgba(23,31,57,0.001)' }
          //   ]
          // ),
          backgroundColor: !legendBackgroundColor
            ? "rgba(255, 255, 255, 0)"
            : "rgba(242,245,255,1)",
          borderRadius: [8, 8, 8, 8],
          shadowColor: "rgba(255, 255, 255, 0)",
          textStyle: {
            fontSize:
              legendListFontSize ||
              (isExportTextColor
                ? 25
                : circleSize && !isShowTextColor
                ? circleSize / 5
                : isShowTextColor
                ? 25
                : 12),
            color: !legendBackgroundColor ? "#D8DDE3" : "#262A3E",
            rich: {
              name: {
                verticalAlign: "right",
                align: "left",
                // fontSize: 18,
                color: "#D8DDE3",
              },
              percent: {
                padding: [0, 0, 0, 10],
                color: "#D8DDE3",
                // fontSize: 12,
              },
            },
          },
          data: legendData,
        },
        series: [
          // 中间数据圈
          {
            right: seriesRight || "35%",
            name: "",
            type: "pie",
            radius: [
              circleSize ? `${circleSize - 40}%` : "40%",
              circleSize ? `${isExportTextColor ? 50 : circleSize}%` : "65%",
            ],
            center: [pieCenter || "50%", "50%"],
            minAngle: 10, // 最小角度
            avoidLabelOverlap: true,
            // startAngle: 270, //起始角度
            // avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center", // 是否显示在内圈
              // show: true,
              // position: 'outside',  //是否显示在外圈
              formatter: ["{value|{c}}", `{name|{b}${innerText}}`].join("\n"),
              // formatter: function (a) { return a.name + ' : ' + a.percent.toFixed(0) + '%' },
              color: "#fff",
              fontSize: 12,
              rich: {
                value: {
                  color: "#fff",
                  fontSize: 25,
                  fontWeight: "bold",
                  lineHeight: 40,
                },
                name: {
                  color: "#707F9D",
                  lineHeight: 20,
                },
              },
            },
            emphasis: {
              label: {
                show: false, // 是否显示文字
                fontSize: "15",
                fontWeight: "bold",
                color: "#FFFFFF",
                // formatter: function (a) {
                //   return total
                // },
              },
            },
            labelLine: {
              // 引导线
              show: true,
              length: 8,
              length2: 8,
            },
            z: 11,
            data: seriesData,
          },
          // 边框的设置
          {
            right: seriesRight || "35%",
            // name: '最内圈',
            // radius: ['32%', '40%'],
            radius: [
              circleSize ? `${circleSize - (isExportTextColor ? 40 : 50)}%` : "32%",
              circleSize ? `${isExportTextColor ? 20 : circleSize - 40}%` : "40%",
            ],
            center: [pieCenter || "50%", "50%"],
            type: "pie",
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            data: [
              {
                value: 0,
                itemStyle: {
                  // color: "rgba(250,250,250,0.3)",
                  color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "rgba(40,55,92,1)" },
                    { offset: 1, color: "rgba(23,31,57,0.001)" },
                  ]),
                },
              },
            ],
          },
          {
            right: seriesRight || "35%",
            // name: '最外圈',
            type: "pie",
            hoverAnimation: false, // 鼠标移入变大
            // radius: ['65%', '65%'],
            radius: [
              circleSize ? `${isExportTextColor ? 50 : circleSize + 3}%` : "65%",
              circleSize ? `${isExportTextColor ? 50 : circleSize + 3}%` : "65%",
            ],
            center: [pieCenter || "50%", "50%"],
            label: {
              normal: {
                show: false,
              },
            },
            animation: false,
            tooltip: {
              show: false,
            },
            data: [
              {
                value: 0,
                itemStyle: {
                  normal: {
                    borderWidth: 40,
                    borderColor: !legendBackgroundColor
                      ? this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                          { offset: 0, color: "rgba(40,55,92,1)" },
                          { offset: 1, color: "rgba(23,31,57,0.001)" },
                        ])
                      : this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                          { offset: 0, color: "rgba(233,240,255,1)" },
                          { offset: 1, color: "rgba(255,255,255,0.8)" },
                        ]),
                  },
                },
              },
            ],
          },
        ],
      };
      // 渲染图表
      this.pieEcharts.setOption(this.pieOption);
      this.pieEcharts.resize();
      window.addEventListener("resize", () => {
        this.pieEcharts.resize();
      });
    },
  },
};
</script>

<style scoped></style>
